import * as actions from 'appRedux/actions/taxInvoice/lookupActionType';

export interface LookupState {
  [key: string]: {
    loader: boolean;
    dataSource: any[];
    error: string | null;
    paging?: {
      current?: number;
      limit?: number;
      row_count?: number;
      total_rows?: number;
    };
    process: {
      status: boolean;
      action: string;
      message: string;
    };
  };
}

const initialState: LookupState = {};

// Helper function to get initial state for a lookup type
const getInitialState = (lookupType: actions.LookupType) => ({
  loader: false,
  dataSource: [],
  error: null,
  process: {
    status: false,
    action: `lookup_${lookupType}`,
    message: '',
  },
});

export default (
  state: LookupState = initialState,
  action: actions.LookupAction
): LookupState => {
  switch (action.type) {
    case actions.LOOKUP_REQUEST: {
      const { lookupType } = action.payload;
      return {
        ...state,
        [lookupType]: {
          ...(state[lookupType] || getInitialState(lookupType)),
          loader: true,
          error: null,
          process: {
            status: false,
            action: `lookup_${lookupType}`,
            message: '',
          },
        },
      };
    }

    case actions.LOOKUP_SUCCESS: {
      const { lookupType, response } = action.payload;
      // Support both structures: result_data as array or result_data.items
      const resultData: any = response.data?.result_data || {};
      const items = Array.isArray(resultData) ? resultData : (resultData?.items || []);
      const paging = resultData?.paging || {};

      return {
        ...state,
        [lookupType]: {
          ...(state[lookupType] || getInitialState(lookupType)),
          loader: false,
          dataSource: items,
          paging: paging && Object.keys(paging).length > 0 ? {
            current: paging.current,
            limit: paging.limit,
            row_count: paging.row_count,
            total_rows: paging.total_rows,
          } : undefined,
          error: null,
          process: {
            status: true,
            action: `lookup_${lookupType}`,
            message: response.data?.result_msg || 'Success',
          },
        },
      };
    }

    case actions.LOOKUP_ERROR: {
      const { lookupType, message } = action.payload;
      return {
        ...state,
        [lookupType]: {
          ...(state[lookupType] || getInitialState(lookupType)),
          loader: false,
          error: message,
          process: {
            status: false,
            action: `lookup_${lookupType}`,
            message,
          },
        },
      };
    }

    case actions.LOOKUP_RESET: {
      const { lookupType } = action.payload;
      const newState = { ...state };
      delete newState[lookupType];
      return newState;
    }

    default:
      return state;
  }
};

